import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
// import { LoggingService } from '../services';
import { NotificationsService, Notification } from '../helper-components/index'
import * as StackTrace from 'stacktrace-js';
import { ErrorModel, HttpErrorModel } from './error.model';
import { MessageBrokerService } from './message-broker.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  defaultErrorMessage: string = 'Apologies, something went wrong, please mention the following error/code when requesting help: ';
  timeoutErrorMessage: string = 'Your session has timed out. Please log in again by reloading the page.';

  xssMessage: string = 'Please check your input(s), remove any angled brackets ("<", ">").';

  constructor(private injector: Injector) {
    super();
  }
  processError(err: any) {
    console.error("GlobalErrorHandler.processError(): custom handled error: ", err);
    super.handleError(err);
    
    this.handleError(err, true);
  }

  handleError(error, customHandle: boolean = false) {
    
    const notificationService = this.injector.get(NotificationsService);
    const loggingService = this.injector.get(LoggerService);
    const messageBrokerService = this.injector.get(MessageBrokerService);
    
    try {
      var serverError: ErrorModel;
      try {
        serverError = error.json();
        console.error('GlobalErrorHandler.processError() >> parsed error:' + JSON.stringify(serverError));
      } catch (e) {
        //this may not be a json object, try text
        console.log('exception when parsing error: ' + error + ', exception:' + e);
      }

      var httpError: HttpErrorModel;
      //404 should not be fall in here (this is typically for service calls), but just in case...
      if (error.status && error.status != 500) {
        
        if (error.status === 404) {
          notificationService.add(new Notification('warn', "NOT_FOUND"));
          console.warn(JSON.stringify(error));
          return;
        }

        httpError = this.getHttpError(error);
        
        if (error.status === 401) {  //401 are special cases, we should show a friendly new page to refresh or re-login
          if (httpError && httpError.errorCode) {
            //check if it's not a 
            if (httpError.errorCode === 'INVALID_SESSION_ID') {
              let rerouteError: ErrorModel = new ErrorModel();
              rerouteError.reloadRoute = '/';
              rerouteError.shouldRefreshApp = false;
              rerouteError.httpError = httpError;
              rerouteError.Message = this.timeoutErrorMessage;
              rerouteError.shouldRefreshApp = true;
              messageBrokerService.showErrorScreen(rerouteError);
            } else {
              notificationService.add(new Notification('exception', httpError.errorCode, this.timeoutErrorMessage));
            }
          }else{
            //notificationService.add(new Notification('exception', error.status, this.timeoutErrorMessage));
          }
        }
        return;
      }

      //this over here is normally for 500 (or none of the 400ish above)
      if (serverError && serverError.ExceptionId) {
        notificationService.add(new Notification('exception', serverError.ExceptionId));
        return;
      }

      //sometimes the below is enough
      if (httpError && httpError.errorCode) {
        notificationService.add(new Notification('exception', httpError.errorCode, this.defaultErrorMessage));
        return;
      }

      //when no errorCode is present, we show the text
      if (error.statusText) {
        notificationService.add(new Notification('exception', error.statusText));
        return;
      }

      var errorMessage = ' ' + error;
      if ( errorMessage &&  errorMessage.toLowerCase().includes('tweenscontainer')){
          //This error comes from Velocity and they claimed they have fixed it in a newer version. 
          //Such error does not affect the behaviour of Scrims
          return;
      }
      
      console.warn('Unconventional Error so far: ' + error);

      //worst case, we do the actual error or unknown as fallback
      // var unknownError;
      // try {
      //   unknownError = JSON.stringify(error);
      // } catch (e) {
      //   unknownError = error;
      // }
      notificationService.add(new Notification('exception', 'SYSTEM ERROR'));

      console.error(error);

      // loggingService.log(err.message);

      if (!customHandle)
        throw error;

    }

    catch (e) {
      notificationService.add(new Notification('exception', e.message.substring(0, 100)));
      console.error(e);
    }

  }

  private getHttpError(error: any): HttpErrorModel {

    try {
      let httpErrors: HttpErrorModel[] = error.json();
      var httpError: HttpErrorModel;

      if (httpErrors && httpErrors.length > 0) {
        httpError = httpErrors[0];
      }
      return httpError;
    } catch (e) {
      console.log('Could not parse error: ' + error + ' to a proper Http Error');
    }

  }
}

@Injectable()
export class LoggerService {
  constructor() {

  }

  log(error) {
    console.error("LoggerService.log()", error);
    // this.notificationService.add(new Notification('exception', error.statusText));
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/error-handler.ts